module.exports = ""


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/snack-bar/snack-bar.component.html
// module id = ../../../../../src/app/shared/snack-bar/snack-bar.component.html
// module chunks = main